import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import axios from 'axios';
import '../../styles/calendrier.css';

const API_URL = "https://ahuncycle-backend.vercel.app";
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageCalendrier = () => {
  const [dateSelectionnee, setDateSelectionnee] = useState(new Date());
  const [evenements, setEvenements] = useState([]);
  const [evenementModal, setEvenementModal] = useState(null);

  useEffect(() => {
    const chargerEvenements = async () => {
      try {
        const res = await axiosInstance.get('/api/evenements');
        setEvenements(res.data);
      } catch (err) {
        console.error("Erreur lors du chargement des événements :", err);
      }
    };
    chargerEvenements();
  }, []);

  const getEventsForDate = (date) => {
    const dateStr = date.toISOString().split('T')[0];
    return evenements.filter(evt => evt.date.split('T')[0] === dateStr);
  };

  const getEventsForMonth = (date) => {
    const month = date.getMonth();
    const year = date.getFullYear();
    const today = new Date();

    return evenements.filter(evt => {
      const evtDate = new Date(evt.date);
      return (
        evtDate.getMonth() === month &&
        evtDate.getFullYear() === year &&
        evtDate >= today
      );
    });
  };

  const eventsForCurrentMonth = getEventsForMonth(dateSelectionnee);

  const handleTileClick = (date) => {
    const dayEvents = getEventsForDate(date);
    setEvenementModal({ date, events: dayEvents });
  };

  return (
    <div className="max-w-6xl mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6 text-center">Calendrier des activités</h1>

      <div className="mb-6">
        <Calendar
          onChange={setDateSelectionnee}
          value={dateSelectionnee}
          tileContent={({ date, view }) => {
            const dayEvents = getEventsForDate(date);
            return view === 'month' && dayEvents.length > 0 ? (
              <div className="events-container">
                {dayEvents.map((e, i) => (
                  <div
                    key={i}
                    className="text-xs text-green-700 truncate cursor-pointer event-point"
                    onClick={() => handleTileClick(date)}
                  >
                    • {e.titre}
                  </div>
                ))}
              </div>
            ) : null;
          }}
          onClickDay={handleTileClick}
          className="custom-calendar"
        />
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-4 text-center">
          Événements à venir en {dateSelectionnee.toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}
        </h2>
        {eventsForCurrentMonth.length === 0 ? (
          <p className="text-center">Aucun événement prévu ce mois-ci.</p>
        ) : (
          <ul className="space-y-4">
            {eventsForCurrentMonth
              .sort((a, b) => new Date(a.date) - new Date(b.date))
              .map((evt) => (
                <li key={evt._id} className="bg-white border p-4 rounded shadow">
                  <p className="text-sm text-gray-600 font-medium mb-1">
                    {new Date(evt.date).toLocaleDateString()}
                  </p>
                  <h3 className="font-bold text-lg">{evt.titre}</h3>
                  <p>{evt.description}</p>
                  {evt.lien && (
                    <a
                      href={evt.lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      Voir l'événement
                    </a>
                  )}
                </li>
              ))}
          </ul>
        )}
      </div>

      {evenementModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg relative max-h-[80vh] overflow-y-auto">
            <button
              onClick={() => setEvenementModal(null)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>

            <h2 className="text-xl font-bold mb-4">
              {evenementModal.events.length > 0
                ? `Événements le ${new Date(evenementModal.date).toLocaleDateString()}`
                : `Aucun événement à cette date`}
            </h2>

            {evenementModal.events.length > 0 ? (
              evenementModal.events.map((evt, index) => (
                <div key={index} className="mb-4 border-b pb-4">
                  <h3 className="text-lg font-semibold">{evt.titre}</h3>
                  <p className="text-sm text-gray-600 mt-1">{evt.description}</p>
                  {evt.lien && (
                    <a
                      href={evt.lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block mt-2 text-blue-600 underline"
                    >
                      Voir l'événement
                    </a>
                  )}
                </div>
              ))
            ) : (
              <p>Aucun événement prévu pour cette date.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PageCalendrier;
